import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Polizza } from 'src/app/models/polizza';
import { PolizzaService } from 'src/app/services/polizza.service';
import { findInRoute } from 'src/app/shared/utilities';

@Component({
  selector: 'polizza-view',
  templateUrl: './polizza-view.component.html',
  styleUrls: ['./polizza-view.component.scss']
})
export class PolizzaViewComponent implements OnInit {

  polizza: Polizza;

  constructor(private activatedRoute: ActivatedRoute,
    private polizzaService: PolizzaService,) { }

  async ngOnInit() {
    let idPolizza = +findInRoute('idPolizza', this.activatedRoute);
    this.polizza = await this.polizzaService.getOne(idPolizza, ['compagnia', 'agenzia', 'ramo', 'contraente']);
  }

}
